"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSubtypeSelect = void 0;
const react_1 = __importDefault(require("react"));
const SelectInput_1 = __importDefault(require("./SelectInput"));
const product_1 = require("@treez/commons/utils/product");
exports.ProductSubtypeSelect = (props) => {
    const { productType } = props, restOfProps = __rest(props, ["productType"]);
    return (react_1.default.createElement(SelectInput_1.default, Object.assign({ label: 'Subtype', options: productType ? product_1.getValidSubtypes(productType) : [], placeholder: 'Select Type' }, restOfProps)));
};
exports.default = exports.ProductSubtypeSelect;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvZHVjdFN1YnR5cGVTZWxlY3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZm9ybXMvUHJvZHVjdFN1YnR5cGVTZWxlY3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsa0RBRWlFO0FBQ2pFLGdFQUF5RTtBQUV6RSwwREFBd0Y7QUFpQjNFLFFBQUEsb0JBQW9CLEdBQUcsQ0FBQyxLQUFZLEVBQUUsRUFBRTtJQUNqRCxNQUFNLEVBQ0YsV0FBVyxLQUVYLEtBQUssRUFERixXQUFXLFVBQ2QsS0FBSyxFQUhILGVBR0wsQ0FBUSxDQUFDO0lBRVYsT0FBTyxDQUNILDhCQUFDLHFCQUFXLGtCQUNSLEtBQUssRUFBWSxTQUFTLEVBQzFCLE9BQU8sRUFBVSxXQUFXLENBQUMsQ0FBQyxDQUFDLDBCQUFnQixDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQ2pFLFdBQVcsRUFBSSxhQUFhLElBQ3hCLFdBQVcsRUFDakIsQ0FDTCxDQUFDO0FBQ04sQ0FBQyxDQUFDO0FBRUYsa0JBQWUsNEJBQW9CLENBQUMifQ==